export default __webpack_public_path__ + "static/bg@3x-3b7ccf11196a10e002fd07c7302c733b.webp";